import "./PopupInfo.css";
import CloseCircle from "../img/close-cirlce.svg";

export default function ({ popup, popupType, closeNav }) {
  return (
    <div className={popup ? "popup-info" : "popup-info popup-hidden"}>
      {popupType === "phone" && (
        <>
          <a className="hidden-nav-link close-button">
            <img src={CloseCircle} alt="close button" onClick={closeNav} />
          </a>
          <a href="tel:2532012345" className="hidden-nav-link">
            2532012345
          </a>
          <a href="tel:6940404044" className="hidden-nav-link">
            6940404044
          </a>
        </>
      )}
      {popupType === "mail" && (
        <>
          <a className="hidden-nav-link close-button">
            <img src={CloseCircle} alt="close button" onClick={closeNav} />
          </a>
          <a href="mailto:abcdef@gmail.com" className="hidden-nav-link">
            abcdef@gmail.com
          </a>
        </>
      )}
      {popupType === "hours" && (
        <>
          <a className="hidden-nav-link close-button">
            <img src={CloseCircle} alt="close button" onClick={closeNav} />
          </a>
          <a href="tel:2532012345" className="hidden-nav-link">
            hours
          </a>
        </>
      )}
    </div>
  );
}
